import React from 'react';
import {
    Tag,
    Row,
    Space,
    Button,
    Input,
    DatePicker,
    Select,
    Table,
    Pagination,
    Checkbox,
    Tabs,
    Rate,
    Col,
    Popconfirm,
    message
} from 'antd';
import {Redirect, Link, withRouter} from 'react-router-dom';
import store from "../store/store.js";
import {PlusOutlined} from '@ant-design/icons'
import {PaperClipOutlined, LinkOutlined, SendOutlined, SearchOutlined, ReloadOutlined} from '@ant-design/icons'
import moment from 'moment';
import Edit from './edit.js'
import View from './view.js'


const {Option} = Select;
const {RangePicker} = DatePicker;
const {TabPane} = Tabs;

class Index extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            newcondition: {}, oldcondition: {}, list: [], tableloading: false, selectedRowKeys: [], count: 0,
        };
        store.subscribe(() => {
            // console.log('state状态改变了，新状态如下')
            // console.log(store.getState().data.isLogin)
        })
    }

    componentWillMount() {
        this.props.GET_REFRESH(this.getdata)
    }

    componentDidMount() {
        // console.log(this.props)
        // let pathname = this.props.location.pathname
        this.props.NAV_CHANGE('/hetong_cs', ['首页', '合同管理', '测试合同'])
        setTimeout(this.getdata(1, null))

    }

    onTimeChange(name, date, dateString) {
        let that = this
        console.log(name, date, dateString)
        let data = Object.assign({}, this.state.newcondition, {[name]: dateString})
        this.setState({
            newcondition: data
        })
    }

    onSelChange(name, value) {
        let that = this
        console.log(name, value)
        let data = Object.assign({}, this.state.newcondition, {[name]: value})
        this.setState({
            newcondition: data
        })
    }

    arrsel(arr) {
        if (arr) {
            return arr.map((item, index) => <Option value={item.id} key={index}>{item.name}</Option>)
        }
    }

    onChange(name, e) {
        let that = this
        let value = e.target.value
        console.log(name, value)
        let data = Object.assign({}, this.state.newcondition, {[name]: value})
        this.setState({
            newcondition: data
        })
    }

    onRangeChange(name, dates, dateStrings) {
        console.log(name, dates, dateStrings)
        var data = Object.assign({}, this.state.newcondition, {
            [name + '1']: dateStrings[0], [name + '2']: dateStrings[1]
        })
        if (data) {
            this.setState({
                newcondition: data
            })
        }
    }

    pagechange(page, pagesize) {
        let that = this
        console.log(page, pagesize)
        let data = Object.assign({}, this.state.oldcondition, {current: page, pagesize: pagesize})
        setTimeout(() => {
            this.setState({
                oldcondition: data
            })
            that.getdata(0, null)
        })
    }

    onSelectChange = selectedRowKeys => {
        console.log('selectedRowKeys changed: ', selectedRowKeys);
        this.setState({selectedRowKeys});
    };

    onCheckboxChange(name, e) {
        let that = this
        let value = e.target.checked
        console.log(name, value)
        let data = Object.assign({}, this.state.newcondition, {[name]: value})
        this.setState({
            newcondition: data
        })
    }

    getdata = (subtype = 0, e) => {
        let that = this
        that.setState({
            tableloading: true
        })
        if (subtype == 1) {
            var arr = that.state.newcondition
            let old = that.state.oldcondition
            arr = Object.assign({}, arr, {current: 1, pagesize: old.pagesize})
            that.setState({
                oldcondition: arr
            })
        } else {
            var arr = Object.assign({}, this.state.oldcondition, {})
        }
        arr.yuanqu = store.getState().data.yuanqu ? store.getState().data.yuanqu : null
        fetch('/Contract/index2', {
            // post提交
            method: "POST", body: JSON.stringify(arr)
        })
            .then(res => res.json())
            .then(data => {
                //
                that.setState({
                    list: data.datalist,
                    status_react: data.status_react ? data.status_react : [],
                    yq_react: data.yq_react ? data.yq_react : [],
                    tableloading: false,
                    count: Number(data.count)
                })
            })
    }

    delSel() {
        let that = this
        fetch('/Contract/allsave2', {
            method: "POST", body: JSON.stringify({
                id: this.state.selectedRowKeys,
            })
        })
            .then(res => res.json())
            .then(data => {
                if (data.status == 0) {
                    message.error(data.msg)
                    return
                }
                this.pagechange(1, this.state.oldcondition.pagesize)
                that.setState({
                    selectedRowKeys: []
                })
            })
    }

    reset() {
        let that = this
        that.setState({
            newcondition: {}, oldcondition: {},
        })
        setTimeout(() => {
            that.getdata(1, null)
        })
    }

    download(type) {
        // type==1 下载选中部分
        let that = this
        that.setState({
            downloading: true
        })
        var arr = Object.assign({}, this.state.oldcondition, {})
        if (type == 1) {
            arr = {
                id: that.state.selectedRowKeys
            }
        }
        arr.download = 1
        arr.yuanqu = store.getState().data.yuanqu ? store.getState().data.yuanqu : null
        fetch('/Contract/index2', {
            // post提交
            method: "POST", body: JSON.stringify(arr)
        })
            .then(res => res.json())
            .then(data => {
                if (data.status == 0) {
                    message.error(data.msg);
                    return
                }

                that.setState({
                    downloading: false
                })
                try {
                    var elemIF = document.createElement("iframe");
                    elemIF.src = data.url;
                    elemIF.style.display = "none";
                    document.body.appendChild(elemIF);
                } catch (e) {
                    alert("下载异常！");
                }
            })
    }

    render() {
        const columns = [{
            title: '合同编号',
            dataIndex: 'ref',
            key: 'ref',
            width: 120,
            fixed: 'left',
            render: (row, record) => {
                return (<>
                    <View id={record.id} title={row} refresh={this.getdata.bind(this)}/>
                </>)
            },
        }, {
            title: '企业名称',
            dataIndex: 'company_name',
            key: 'company_name',
            // width:200,
            render: (row, record) => {
                return (<>
                    <div>{row}</div>
                    {record.aliasname ? <div style={{color:'grey'}}>曾用名：{record.aliasname}</div> : null}
                </>)
            },
        }, {
            title: '所属园区',
            dataIndex: 'yq_id',
            key: 'yq_id',
            width: 150,
        }, {
            title: '生效时间',
            dataIndex: 'sxtime',
            key: 'sxtime',
            width: 220,
        }, {
            title: '计费标准',
            dataIndex: 'jfbz',
            key: 'jfbz',
            width: 300,
            render: (row, record) => {
                return (<>
                    <Space direction={"vertical"}>{row}</Space>
                </>)
            },
        }, {
            title: '时长',
            dataIndex: 'duration',
            key: 'duration',
            width: 130,
        }, {
            title: '金额',
            dataIndex: 'amount',
            key: 'amount',
            width: 120,
        }, {
            title: '添加人',
            dataIndex: 'aid',
            key: 'aid',
            width: 120,
        }, {
            title: '操作',
            dataIndex: 'cz',
            key: 'cz',
            align: 'center',
            fixed: 'right',
            width: 120,
            render: (row, record) => {
                return (<>
                    <Space>
                        <View id={record.id} refresh={this.getdata.bind(this)}/>
                        {store.getState().data.info.lmqx_tj ? (store.getState().data.info.lmqx_tj.includes('102') ?
                            <Edit refresh={this.getdata.bind(this)} id={record.id}/>
                            : null) : null}
                    </Space>
                </>)
            },
        },]
        const {tableloading, selectedRowKeys} = this.state;
        const rowSelection = {
            selectedRowKeys, onChange: this.onSelectChange.bind(this), // hideSelectAll: true,
            preserveSelectedRowKeys: false,
        };
        const hasSelected = selectedRowKeys.length > 0;
        return (<>
            <Row justify="space-between" align="top" style={{marginBottom: 15}}>
                <Space wrap>
                    <Input className="input" placeholder="合同编号/企业名称"
                           value={this.state.newcondition.keywords ? this.state.newcondition.keywords : null}
                           onChange={this.onChange.bind(this, 'keywords')} autoComplete="off"/>
                    {/*<Select placeholder="所属园区"
                            style={{width: 120}}
                            value={this.state.newcondition.yq_id ? this.state.newcondition.yq_id : null}
                            onChange={this.onSelChange.bind(this, 'yq_id')} allowClear>
                        {this.arrsel(this.state.yq_react)}
                    </Select>*/}
                    <RangePicker allowEmpty={[true, true]} onChange={this.onRangeChange.bind(this, 'stime')}
                                 value={[(this.state.newcondition.stime1 ? moment(this.state.newcondition.stime1) : null), (this.state.newcondition.stime2 ? moment(this.state.newcondition.stime2) : null)]}
                                 placeholder={['生效时间', '生效时间']}/>
                    <Input className="input" placeholder="添加人"
                           value={this.state.newcondition.keyword ? this.state.newcondition.keyword : null}
                           onChange={this.onChange.bind(this, 'keyword')} autoComplete="off"/>
                    <Button type="primary" icon={<SearchOutlined/>}
                            onClick={this.getdata.bind(this, 1)}>查询</Button>
                    <Button type="primary" icon={<ReloadOutlined/>} className='huise'
                            onClick={this.reset.bind(this)}>重置</Button>
                </Space>
                {store.getState().data.info.lmqx_bj ? (store.getState().data.info.lmqx_bj.includes('102') ?
                    <Edit refresh={this.getdata.bind(this)}/>
                    : null) : null}
            </Row>
            <Table
                bordered
                columns={columns}
                dataSource={this.state.list}
                pagination={false}
                loading={tableloading}
                rowSelection={rowSelection}
                className='table'
                // scroll={{x: 2800}}
                style={{marginBottom: 20}}
            />
            <Row justify={'space-between'}>
                <div className='l'>
                    <Space wrap>
                        {hasSelected ? <>
                            {store.getState().data.info.lmqx_sc ? (store.getState().data.info.lmqx_sc.includes('102') ?
                                <>
                                    <Popconfirm
                                        title="确认删除?"
                                        onConfirm={() => this.delSel()}
                                        okText="确认"
                                        cancelText="取消"
                                    >
                                        <Button type="primary" danger>删除</Button>
                                    </Popconfirm>
                                </>
                                : null) : null}
                            {store.getState().data.info.lmqx_dc ? (store.getState().data.info.lmqx_dc.includes('102') ?
                                <Button type="primary"
                                        onClick={() => this.download(1)}>导出</Button> : null) : null}
                        </> : null}
                        {store.getState().data.info.lmqx_dc ? (store.getState().data.info.lmqx_dc.includes('102') ?
                            <Button type="primary" onClick={() => this.download()}>全部导出</Button>
                            : null) : null}
                    </Space>
                </div>
                <Pagination showQuickJumper
                            current={this.state.oldcondition.current ? this.state.oldcondition.current : 1}
                            pageSize={this.state.oldcondition.pagesize ? this.state.oldcondition.pagesize : 10}
                            total={this.state.count} onChange={this.pagechange.bind(this)} showSizeChanger={true}
                            showTotal={total => `共 ${total} 条数据`}/>
            </Row>
        </>)
    }
}

export default (props) => <Index {...props} key={props.location.pathname}/>
